export const environment = {
  production: true,
  PACIENTE_LOGIN:'DOCUMENTO', //MAIL o DOCUMENTO
  MEDICO_LOGIN:'DOCUMENTO', //MAIL o DOCUMENTO
  BOTON_CONTACTO:'Enviar Consulta',
  BASE_TYPEOFESTUDIOS: 1,//1 modo normal 0 el otro
};
